module.exports = __webpack_public_path__ + "static/media/camera-lens.93ccc0f6.png";